!(function (t, e) {
  "function" == typeof define && define.amd
    ? define([], e)
    : "object" == typeof exports
    ? (module.exports = e())
    : (t.Marquee3k = e());
})(this, function () {
  "use strict";
  let MARQUEES = [];
  let isListening = false;

  class e {
    constructor(t, e) {
      if (!t || !t.querySelector(".marquee-scrolling-item")) {
        console.warn("Marquee3k: Element has no .marquee-scrolling-item.");
        return;
      }

      // Skip already-initialized elements to prevent double-init from multiple init() calls
      if (t.classList.contains("is-init")) return;

      this.element = t;
      this.selector = e.selector;
      this.speed = parseFloat(t.dataset.speed) || 1;
      this.pausable = t.dataset.pausable === "true" ? 1 : -1;
      this.reverse = t.dataset.reverse === "true";
      this.paused = false;
      this.parent = t.parentElement;
      this.parentProps = this.parent.getBoundingClientRect();
      this.content = t.children[0];
      this.innerContent = this.content.innerHTML;
      this.offset = 0;
      this._setupWrapper();
      this._setupContent();
      this._setupEvents();
      this.wrapper.appendChild(this.content);
      this.element.appendChild(this.wrapper);
      this.lastFrameTime = null;
    }

    _setupWrapper() {
      this.wrapper = document.createElement("div");
      this.wrapper.classList.add("marquee3k__wrapper");
      this.wrapper.style.whiteSpace = "nowrap";
    }

    _setupContent() {
      this.content.classList.add(`${this.selector}__copy`);
      this.content.style.display = "inline-block";
      this.contentWidth = this.content.offsetWidth;
      this.parentProps = this.parent.getBoundingClientRect();

      // Guard: if contentWidth is 0 the division below produces Infinity → infinite clone loop
      if (!this.contentWidth) return;

      this.requiredReps = Math.min(
        this.contentWidth > this.parentProps.width
          ? 2
          : Math.ceil((this.parentProps.width - this.contentWidth) / this.contentWidth) + 1,
        20  // hard cap — prevents runaway cloning if measurements are unreliable
      );

      for (let i = 0; i < this.requiredReps; i++) this._createClone();
      if (this.reverse) this.offset = -1 * this.contentWidth;
      this.element.classList.add("is-init");
    }

    _setupEvents() {
      // Store bound handlers so they can be removed in destroy()
      this._onMouseEnter = () => { if (this.pausable) this.paused = true; };
      this._onMouseLeave = () => { if (this.pausable) this.paused = false; };
      this.element.addEventListener("mouseenter", this._onMouseEnter);
      this.element.addEventListener("mouseleave", this._onMouseLeave);
    }

    _createClone() {
      const clone = this.content.cloneNode(true);
      clone.style.display = "inline-block";
      clone.classList.add(`${this.selector}__copy`);
      this.wrapper.appendChild(clone);
    }

    // Clears all clones and rebuilds the correct number — used on resize
    _reset() {
      // Measure BEFORE touching the DOM.
      // If contentWidth is 0 (element unmeasurable mid-resize / DevTools opening),
      // bail out now — clones and this.contentWidth stay intact so animation keeps running.
      const newContentWidth = this.content.offsetWidth;
      const newParentProps = this.parent.getBoundingClientRect();
      if (!newContentWidth || !newParentProps.width) return;

      // Measurements are valid — safe to remove old clones and rebuild
      while (this.wrapper.children.length > 1) {
        this.wrapper.removeChild(this.wrapper.lastChild);
      }

      this.contentWidth = newContentWidth;
      this.parentProps = newParentProps;

      this.requiredReps = Math.min(
        this.contentWidth > this.parentProps.width
          ? 2
          : Math.ceil((this.parentProps.width - this.contentWidth) / this.contentWidth) + 1,
        20  // hard cap — prevents runaway cloning if measurements are unreliable
      );

      for (let i = 0; i < this.requiredReps; i++) this._createClone();
      if (this.reverse) this.offset = -1 * this.contentWidth;
    }

    // Fully tears down this instance so init() can safely run again on this element
    destroy() {
      this.element.removeEventListener("mouseenter", this._onMouseEnter);
      this.element.removeEventListener("mouseleave", this._onMouseLeave);

      // Move original content back out of wrapper before removing it
      this.element.insertBefore(this.content, this.wrapper);
      this.wrapper.remove();

      this.content.classList.remove(`${this.selector}__copy`);
      this.element.classList.remove("is-init");
    }

    animate() {
      if (!this.paused) {
        const now = Date.now();
        let deltaTime = 0;
        if (this.lastFrameTime) deltaTime = now - this.lastFrameTime;
        this.lastFrameTime = now;

        const distance = this.speed * deltaTime / 16;
        const shouldContinue = this.reverse
          ? this.offset < 0
          : this.offset > -1 * this.contentWidth;
        const direction = this.reverse ? -1 : 1;
        const resetPoint = this.reverse ? -1 * this.contentWidth : 0;

        this.offset = shouldContinue
          ? this.offset - distance * direction
          : resetPoint;

        this.wrapper.style.whiteSpace = "nowrap";
        this.wrapper.style.transform = `translate(${this.offset}px, 0) translateZ(0)`;
      }
    }

    _refresh() {
      this.contentWidth = this.content.offsetWidth;
    }

    static refresh(i) { MARQUEES[i]._refresh(); }
    static pause(i) { MARQUEES[i].paused = true; }
    static play(i) { MARQUEES[i].paused = false; }
    static toggle(i) { MARQUEES[i].paused = !MARQUEES[i].paused; }
    static refreshAll() { for (let i = 0; i < MARQUEES.length; i++) MARQUEES[i]._refresh(); }
    static pauseAll() { for (let i = 0; i < MARQUEES.length; i++) MARQUEES[i].paused = true; }
    static playAll() { for (let i = 0; i < MARQUEES.length; i++) MARQUEES[i].paused = false; }
    static toggleAll() { for (let i = 0; i < MARQUEES.length; i++) MARQUEES[i].paused = !MARQUEES[i].paused; }

    static destroyAll() {
      for (let i = 0; i < MARQUEES.length; i++) MARQUEES[i].destroy();
      MARQUEES = [];
      isListening = false;
    }

    static init(options = { selector: "marquee3k" }) {
      if (!document.querySelector(`.${options.selector}`)) return;

      const elements = Array.from(document.querySelectorAll(`.${options.selector}`));
      if (!elements.length) return;

      for (let i = 0; i < elements.length; i++) {
        // Skip elements already initialized — prevents duplicate wrappers/clones
        if (elements[i].classList.contains("is-init")) continue;
        const instance = new e(elements[i], options);
        if (instance.content) {
          MARQUEES.push(instance);
        }
      }

      // Guard ensures only one animation loop and one resize listener exist,
      // even if init() is called multiple times from different files
      if (!isListening) {
        function animate() {
          for (let i = 0; i < MARQUEES.length; i++) MARQUEES[i].animate();
          requestAnimationFrame(animate);
        }
        requestAnimationFrame(animate);

        let resizeTimer;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            // _reset() removes all old clones then rebuilds the correct count —
            // replaces the old repopulate() which only ever added, never removed
            for (let i = 0; i < MARQUEES.length; i++) {
              MARQUEES[i]._reset();
            }
          }, 250);
        });

        isListening = true;
      }
    }
  }

  return e;
});

Marquee3k.init();